(ns hai.notes.mini-app
  "The notes mini-app card shared by the home dashboard and the extension
   sidebar: the mini-app frame tinted sticky-yellow with the perforation
   shifted right, and a header kebab restyled to match the round header
   buttons."
  (:require
   [hai.mini-apps.frame :as frame]
   [hai.notes.header :as header]
   [hai.notes.sections :as sections]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(o/defstyled card frame/card
  {:background t/--sticky-yellow-light}
  [:&::before {:left "auto" :right "36px"}]
  [header/bar
   {:border-top-left-radius "16px"
    :border-top-right-radius "16px"}
   [sections/kebab-wrap
    [:button
     {:width "28px" :height "28px" :border-radius "999px"
      :color t/--note-kraft}
     [:&:hover {:background t/--note-kraft-10 :color t/--note-kraft}]]]])
